<div *ngIf="legend && legend.length > 0">
    <span *ngIf="legend.length == 1">{{ 'REVIEW_DATE.COMPLETION_DATE' | translate }} {{ legend[0].reviewDate | localizedDate }}</span>
    <div *ngIf="legend.length > 1">{{ 'REVIEW_DATE.COMPLETION_DATE' | translate }}<br>
        <ul class="footer-person-list" *ngIf="legend.length > 0">
            <li *ngFor="let legendItem of legend; index as i">{{ legendItem.person.name }}: {{ legendItem.reviewDate | localizedDate }}</li>
        </ul>
    </div>
</div>
